
import styled from 'styled-components';

export const UserManagerContainer = styled.div`
    .login__block{
        background-color: #33363C;
        padding: 45px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 24px;
    }
    .login_inner_top_box{
        text-align:center;
        padding-bottom: 5px;
        border-bottom: 1px solid #ffffff;    
    }
    .login_inner_top_box h2{
        color: #ffffff;
    }
    .login_middle_title_box h2{
        color: #36BDBE;
    }
    .login_middle_title_box{
        padding: 20px 0px;
    }
    .login_middle_title_box p{
        color: #ffffff;
    }
    .login-form-forgot{
        color: #36BDBE;
        transition: transform 0.4s ease;
        position: relative;
        display: inline-block; 
        font-size: 13px;
    }
    .login-form-forgot:hover{
        color: #36BDBE;
        transform: scaleX(1.05);
    }

    .login__form__block{
        min-width: 350px;
    }
    .form_input_field .ant-input-affix-wrapper-disabled{
        opacity: 0.3;
    }
    .form_input_field .ant-input-affix-wrapper-disabled:hover{
        background: transparent !important;
        border-color: #ffffff4d;
    }
    .form_input_field .ant-input-affix-wrapper-disabled:hover .ant-input{
        color: #ffffff;
    }
    .login__form__block .ant-form-item .ant-form-item-control-input-content .ant-input-affix-wrapper{
        background: transparent;
        border-color: #ffffff4d;
        transition: border-color 0.6s ease, background-color 0.6s ease, color 0.6s ease;
    }
    .login__form__block .ant-form-item .ant-form-item-control-input-content .ant-input-affix-wrapper:hover{
        border-color: #36BDBE;
        background-color: rgba(54, 189, 190, 0.15);
    }
    .login__form__block .ant-form-item .ant-form-item-control-input-content .ant-input-affix-wrapper:hover .ant-input::placeholder{
        color: #36BDBE;
    }
    .login__form__block .ant-form-item .ant-form-item-control-input-content .ant-input-affix-wrapper:hover .ant-input{
        color: #36BDBE;
    }
    .login__form__block .ant-form-item .ant-form-item-control-input-content .ant-input-affix-wrapper:hover svg path{
        stroke: #36BDBE !important;
    }
    .user_control_btn{
        background: transparent;
        border: 1px solid #36BDBE;
        border-radius: 8px;
        color: #36BDBE;
        width: 100%;
        transition: background-color 0.6s ease, border-color 0.6s ease, color 0.6s ease;
    }
    .user_control_btn:hover{
        background-color: #36BDBE !important;
        color:#ffffff !important;
        border: 1px solid #36BDBE !important;
    }
    .form_input_field_password{
        margin-bottom: 0px !important;
    }
    .forgot__link__box{
        margin-bottom: 6px;
        text-align: right;
    }
    input:-internal-autofill-selected {
        /* Change the color to your desired color */
        background-color: transparent !important;
    }
    .login_inner_bottom_box{
        text-align: center;
        font-size: 13px;
        color: #36BDBE;
        transition: border 0.6s ease; 
    }
    .login_inner_bottom_box span{
        transition: border-bottom 0.9s ease; 
        cursor: pointer;
    }
    .login_inner_bottom_box span:hover {
        border-bottom: 1px solid #36BDBE; /* Border effect on hover */
    }
    .remember_password_block{
        margin-bottom: 15px;
    }
    .remember_password_block .ant-checkbox-wrapper .ant-checkbox-inner::after {
        border-color: #36BDBE; /* Change to your desired color */
    }
    
    /* Change the color of the checkbox itself */
    .remember_password_block .ant-checkbox-input:checked + .ant-checkbox-inner::after {
        border-color: #000000 !important;  /* Change to your desired color */
        background-color: transparent !important; /* Change to your desired color */
    }

    .remember_password_block .ant-checkbox-checked:not(.ant-checkbox-disabled):hover .ant-checkbox-inner
    {
        background-color: #36BDBE !important;
        border-color: transparent;
    }
    .remember_password_block .ant-checkbox-checked .ant-checkbox-inner{
        background-color: #36BDBE;
        border-color: #36BDBE;
    }

    .form_input_field .ant-input {
        background-color: transparent !important;
        font-size: 13px;
        color: #ffffff; 
    }
    .form_input_field .ant-input::placeholder {
        color: #ffffff; /* Change to your desired color */
    }

    .form_input_field .ant-input:hover {
        background-color: transparent !important; 
    }
    
    .form_input_field .ant-input:focus {
        background-color: transparent !important; 
    }

    .form_input_field .ant-input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 30px white inset !important; /* Adjust the inset shadow color */
        box-shadow: 0 0 0 30px white inset !important; /* Adjust the inset shadow color */
    }
    
    /* For input on hover */
    .form_input_field .ant-input:-webkit-autofill:hover {
        -webkit-box-shadow: 0 0 0 30px white inset !important; /* Adjust the inset shadow color */
        box-shadow: 0 0 0 30px white inset !important; /* Adjust the inset shadow color */
    }
    
    /* For input on focus */
    .form_input_field .ant-input:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0 30px white inset !important; /* Adjust the inset shadow color */
        box-shadow: 0 0 0 30px white inset !important; /* Adjust the inset shadow color */
    }

    .login__block .ant-form-item-with-help .ant-form-item-explain{
        margin-bottom: 10px;
    }
    .login__block .form_input_field .ant-input-affix-wrapper .ant-input-prefix{
        margin-inline-end: 12px;
    }

    // password reset css
    .sendCode_block{
        text-align: right
    }
    .sendCode_block .user_control_btn_link{
        color: #36BDBE;
        font-size: 13px;
        cursor: pointer
    }
    .login__link{
        color: #ffffff;
        justify-content: center;
        display: flex;
        gap: 6px;
        align-items: center;
    }
    .login__link svg{
        font-size: 22px;
    }
    .login__link:hover{
        color: #36BDBE;
    }
    .user_control_btn:disabled{
        opacity: 0.3;
    }
    .user_control_btn_link.text_disable{
        cursor: no-drop;
        color: gray;
    }
`;